{
    "EnablerptrequestauditLabel": "Ativar saída de auditoria de pedido de relatório:",
    "Audit_SectionHeader": "Auditoria",
    "Audit_SectionPara": "Aviso: ative a definição a seguir apenas quando solicitado por um membro da administração da aplicação ou da linha de suporte.",
    "NAME": "Audit"
}